import { formatCurrency } from "../../lib/currency";
import type { CurrencyCode, PartnerBrand } from "../../lib/types";

function describeArc(radius: number): string {
  const xStart = 180 - radius;
  const xEnd = 180 + radius;
  const y = 180;

  return `M ${xStart} ${y} A ${radius} ${radius} 0 0 1 ${xEnd} ${y}`;
}

export function renderGauge(
  valuePerDay: number,
  costPerDay: number,
  currency: CurrencyCode,
  brand: PartnerBrand
): string {
  const max = Math.max(valuePerDay + costPerDay, 200);
  const ratio = Math.min(Math.max(valuePerDay / max, 0), 1);
  // Keep the needle constrained to the top semicircle (left horizon to right horizon).
  const angle = -180 + ratio * 180;

  const ticks = Array.from({ length: 12 }, (_, index) => {
    const tickAngle = Math.PI - (Math.PI * index) / 11;
    const x1 = 180 + Math.cos(tickAngle) * 112;
    const y1 = 180 - Math.sin(tickAngle) * 112;
    const x2 = 180 + Math.cos(tickAngle) * 130;
    const y2 = 180 - Math.sin(tickAngle) * 130;

    return `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" class="gauge-tick" />`;
  }).join("");

  return `
    <div class="gauge-widget">
      <svg viewBox="0 0 360 220" class="gauge-svg" aria-hidden="true">
        <path d="${describeArc(136)}" class="gauge-base" />
        <path d="${describeArc(136)}" class="gauge-fill" style="stroke:${brand.accentColor}" />
        ${ticks}
        <line x1="180" y1="180" x2="300" y2="180" class="gauge-needle" style="transform: rotate(${angle}deg); stroke:${brand.primaryColor}" />
        <circle cx="180" cy="180" r="14" class="gauge-cap" style="fill:${brand.softColor}" />
      </svg>
      <p class="gauge-metric">${formatCurrency(valuePerDay, currency)} <span>(value per day)</span></p>
      <p class="gauge-cost">${formatCurrency(costPerDay, currency)} <span>(cost per day)</span></p>
    </div>
  `;
}
